import CityPageTemplate from "../city-template/CityPageTemplate";
import { winchesterVaConfig } from "./data";

export default function WinchesterVaPage() {
  return <CityPageTemplate config={winchesterVaConfig} />;
}